<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<div class="container-fluid">
			<h1 class="my-2">
				{{ __("Current listed quantities (visible listings only)") }}
			</h1>
			<table class="table">
				<thead>
					<tr>
						<td>{{ __("Article") }}</td>
						<td>{{ __("Buy Offer") }} (t)</td>
						<td>{{ __("Sell offer") }} (t)</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, idx) in stats" :key="idx">
						<td>{{ row.label }}</td>
						<td>{{ row.data.qty__mt__buy }}</td>
						<td>{{ row.data.qty__mt__sell }}</td>
					</tr>
				</tbody>
			</table>
		</div>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		stats: {
			type: Array,
			required: true,
		},
	},
};
</script>
